import React from 'react'

import { Paper, Typography } from '@mui/material'
import { Box } from '@mui/system'

import { BuildingBlocksPromptResponse } from 'models/ideaModels'

import ButtonWithIconComponent from 'components/ButtonWithIcon'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import Section2Title from 'components/Section2Title'
import UserEducationModal from 'components/UserEducationModal'

import refreshIcon from 'assets/images/refreshIcon.svg'

import { styles } from './Section2.styles'

export const TEST_ID = 'building-blocks-section2'

export type Props = {
	buildingBlocksPrompt?: BuildingBlocksPromptResponse
	createPrompt: () => void
	loading: boolean
	reloadIdeas: () => Promise<void>
}

const Section2 = ({ buildingBlocksPrompt, ...props }: Props) => {
	const onClickRefresh = () => {
		props.createPrompt()
	}

	return (
		<>
			<Section2Title />
			<UserEducationModal />
			<Box style={styles.mainBox}>
				<Box sx={styles.sideBar} />
				<Box sx={styles.typographyBox}>
					<Typography
						sx={styles.typography}
						data-testid={`${TEST_ID}-user-directions-verbiage`}
					>
						Consider these GenAI-recommended solutions to the
						innovation topic.
					</Typography>
					<Box sx={styles.refreshButtonBox}>
						<ButtonWithIconComponent
							disabled={props.loading}
							iconSvg={refreshIcon}
							text="REFRESH"
							data-testid={`${TEST_ID}__refresh-button`}
							onClickAction={onClickRefresh}
						/>
					</Box>
					{!buildingBlocksPrompt || props.loading ? (
						<LoadingSpinner />
					) : (
						<Paper elevation={0} sx={styles.paper}>
							<Typography
								sx={{
									...styles.typography,
									...styles.techniqueBox,
								}}
							>
								{typeof buildingBlocksPrompt?.data === 'string'
									? buildingBlocksPrompt.data
									: JSON.stringify(
											buildingBlocksPrompt?.data
										)}
							</Typography>
						</Paper>
					)}
				</Box>
			</Box>
		</>
	)
}
export default Section2
